import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getSyncHistory } from '#/graphql/queries';
import type { GetSyncHistoryQuery } from '#/graphql/types';

const GET_SYNC_HISTORY = gql(getSyncHistory);

const useSyncHistoryQuery = (id?: string) => {
  const query: QueryResult<GetSyncHistoryQuery> = useQuery(GET_SYNC_HISTORY, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useSyncHistoryQuery;
